"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[316],{

/***/ 18630:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.08c8d709.png","height":296,"width":775,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEUTJkJMaXE1YqU3Zqs2ZakWK0o3Zqo2ZakqT4U3Zap0HMvvAAAACnRSTlM8AFKScyYlgC69ZQLOKgAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB9JREFUeJxjYGFmYQQBBk52Zg4GVkZGBjYmJiYGIAAAA+IAPxAOOCUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 76537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function AppStoreSvg(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "white",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#a)",
                fill: "inherit",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.48 11.21c-.55-2.768 2.078-4.392 2.078-4.392s-1.024-1.481-2.745-1.862c-1.72-.382-2.58.095-3.44.453-.86.359-1.289.359-1.289.359-1.24 0-2.148-1.315-4.512-.716-1.63.41-3.344 2.291-3.654 4.536-.31 2.245.359 5.11 1.648 7.33C4.855 19.14 6.168 19.975 7.1 20c.932.024 1.863-.667 2.984-.836 1.123-.166 1.814.407 2.915.717 1.097.31 1.481.022 2.745-1.052 1.267-1.075 2.413-4.157 2.413-4.157s-2.127-.69-2.677-3.46Zm-2.436-8.046C14.264 1.923 13.85 0 13.85 0s-1.71.3-2.858 1.493c-1.145 1.194-.956 3.08-.956 3.08s1.79-.167 3.008-1.409Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "inherit",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppStoreSvg);


/***/ }),

/***/ 5380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function PlayStoreSvg(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "white",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#a)",
                fill: "inherit",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.365.32a2.54 2.54 0 0 0-2.478.006l9.112 8.406 3.06-3.061L4.366.32Zm-3.39.866a2.33 2.33 0 0 0-.35 1.221V17.59c0 .427.117.835.327 1.191l9.163-9.163-9.14-8.431ZM18.118 7.91l-2.92-1.61-3.28 3.28 4.02 3.708 2.181-1.204c.785-.435 1.255-1.215 1.255-2.087 0-.873-.47-1.653-1.256-2.086Zm-7.084 2.554-9.189 9.189c.4.227.837.347 1.277.347.425 0 .852-.107 1.243-.324l10.421-5.75-3.752-3.462Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "inherit",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PlayStoreSvg);


/***/ }),

/***/ 97037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ResponsiveButton; }
});

// UNUSED EXPORTS: ResponsiveButton

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
;// CONCATENATED MODULE: ./src/components/ResponsiveButton/ResponsiveButton.js



function ResponsiveButton(param) {
    let { children , size ="medium" , ...props } = param;
    const theme = (0,useTheme/* default */.Z)();
    const isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const buttonProps = {
        size: isSmallScreen ? "small" : size
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        ...buttonProps,
        ...props,
        children: children
    });
}
/* harmony default export */ var ResponsiveButton_ResponsiveButton = (ResponsiveButton);

;// CONCATENATED MODULE: ./src/components/ResponsiveButton/index.js


/* harmony default export */ var components_ResponsiveButton = (ResponsiveButton_ResponsiveButton);


/***/ }),

/***/ 41547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imports_GetStartedButton; }
});

// UNUSED EXPORTS: GetStartedButton

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./src/components/ResponsiveButton/index.js + 1 modules
var ResponsiveButton = __webpack_require__(97037);
;// CONCATENATED MODULE: ./src/imports/GetStartedButton/GetStartedButton.js




function GetStartedButton(param) {
    let { label ="" , ...buttonProps } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
        href: "/register",
        "aria-label": label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
            disableElevation: true,
            variant: "contained",
            "aria-label": label,
            ...buttonProps,
            children: label
        })
    });
}
/* harmony default export */ var GetStartedButton_GetStartedButton = (GetStartedButton);

;// CONCATENATED MODULE: ./src/imports/GetStartedButton/index.js


/* harmony default export */ var imports_GetStartedButton = (GetStartedButton_GetStartedButton);


/***/ }),

/***/ 99612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imports_LanguageSelect; }
});

// UNUSED EXPORTS: LanguageSelect

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(17417);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(21987);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(84118);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(42096);
// EXTERNAL MODULE: ./node_modules/country-flag-icons/modules/react/3x2/index.js
var _3x2 = __webpack_require__(97235);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/imports/LanguageSelect/LanguageSelect.js










function LanguageSelect(param) {
    let { containerProps ={}  } = param;
    var _i18n_options;
    const router = (0,next_router.useRouter)();
    const { i18n  } = (0,esm/* useTranslation */.$G)();
    var _i18n_options_languages;
    const languages = (_i18n_options_languages = (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.languages) !== null && _i18n_options_languages !== void 0 ? _i18n_options_languages : [];
    const [open, setOpen] = react.useState(false);
    const [anchorEl, setAnchorEl] = react.useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
        setOpen((previousOpen)=>!previousOpen);
    };
    var _languages_find;
    const selectedLanguage = (_languages_find = languages.find((param)=>{
        let { locale  } = param;
        return locale === i18n.language;
    })) !== null && _languages_find !== void 0 ? _languages_find : {};
    var _selectedLanguage_country;
    const FlagComponent = _3x2/* default */.ZP[(_selectedLanguage_country = selectedLanguage.country) !== null && _selectedLanguage_country !== void 0 ? _selectedLanguage_country : "US"];
    const handleLanguageChange = (locale)=>{
        router.replace({
            pathname: router.pathname,
            query: router.query
        }, undefined, {
            locale
        });
    };
    var _selectedLanguage_name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 1,
                alignItems: "center",
                underline: "none",
                onClick: handleClick,
                ...containerProps,
                sx: {
                    ":hover": {
                        cursor: "pointer"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagComponent, {
                            width: 19
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            // fontFamily="var(--cairo-font)"
                            variant: "caption",
                            color: "inherit",
                            children: (_selectedLanguage_name = selectedLanguage.name) !== null && _selectedLanguage_name !== void 0 ? _selectedLanguage_name : "English"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {
                            fontSize: "small",
                            sx: {
                                color: "inherit",
                                mt: 0.8,
                                ml: -0.5
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                open: open,
                anchorEl: anchorEl,
                placement: "bottom",
                sx: {
                    zIndex: 1000
                },
                disablePortal: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                    onClickAway: ()=>setOpen(false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        sx: {
                            zIndex: 1000
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList/* default */.Z, {
                            children: languages.map((param)=>{
                                let { locale , name , country  } = param;
                                const Flag = _3x2/* default */.ZP[country];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: "english",
                                    dense: true,
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        // i18n.changeLanguage(locale)
                                        setOpen(false);
                                        handleLanguageChange(locale);
                                    },
                                    component: NextLink/* default */.Z,
                                    href: "/".concat(locale).concat(router.asPath),
                                    locale: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                children: !!Flag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag, {
                                                    width: 19
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    // fontFamily="var(--cairo-font)"
                                                    variant: "caption",
                                                    color: "inherit",
                                                    children: name
                                                })
                                            })
                                        ]
                                    })
                                }, locale);
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var LanguageSelect_LanguageSelect = (LanguageSelect);

;// CONCATENATED MODULE: ./src/imports/LanguageSelect/index.js


/* harmony default export */ var imports_LanguageSelect = (LanguageSelect_LanguageSelect);


/***/ }),

/***/ 94369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imports_NextLink; }
});

// UNUSED EXPORTS: NextLink

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/imports/NextLink/NextLink.js



function NextLink(param) {
    let { children , style ={} , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        style: {
            textDecoration: "none",
            color: "inherit",
            ...style
        },
        ...props,
        children: children
    });
}
/* harmony default export */ var NextLink_NextLink = (NextLink);

;// CONCATENATED MODULE: ./src/imports/NextLink/index.js


/* harmony default export */ var imports_NextLink = (NextLink_NextLink);


/***/ }),

/***/ 34316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ layouts_MainLayout; }
});

// UNUSED EXPORTS: MainLayout

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js
var AppBar = __webpack_require__(89206);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(83808);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./src/assets/logo.png
var logo = __webpack_require__(18630);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/useScrollPosition.js

const useScrollPosition = ()=>{
    const [scrollPosition, setScrollPosition] = react.useState(0);
    react.useEffect(()=>{
        const updatePosition = ()=>{
            setScrollPosition(window.pageYOffset);
        };
        window.addEventListener("scroll", updatePosition);
        updatePosition();
        return ()=>window.removeEventListener("scroll", updatePosition);
    }, []);
    return scrollPosition;
};
/* harmony default export */ var utils_useScrollPosition = (useScrollPosition);

;// CONCATENATED MODULE: ./src/utils/useScrollBounds.js


const useScrollBounds = (lowerBound, threshold)=>{
    const upperBound = lowerBound + threshold;
    const scrollPosition = utils_useScrollPosition();
    const [visible, setVisible] = react.useState(true);
    react.useEffect(()=>{
        if (!(scrollPosition > lowerBound && scrollPosition < upperBound)) {
            setVisible(scrollPosition < lowerBound);
        }
    }, [
        lowerBound,
        upperBound,
        scrollPosition
    ]);
    return visible;
};
/* harmony default export */ var utils_useScrollBounds = (useScrollBounds);

// EXTERNAL MODULE: ./src/imports/LanguageSelect/index.js + 1 modules
var LanguageSelect = __webpack_require__(99612);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/assets/logo-white.png
/* harmony default export */ var logo_white = ({"src":"/_next/static/media/logo-white.faf0e8f3.png","height":156,"width":412,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEVMaXH+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v4DPOnhAAAACnRSTlMATj8oc5IzYH+9VAHLrwAAAAlwSFlzAAAsSwAALEsBpT2WqQAAAB9JREFUeJxjYGHlYAADTg5WZiZmBgYGZnZGRiYmNkYAA/sAR6CNYUEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./src/imports/GetStartedButton/index.js + 1 modules
var GetStartedButton = __webpack_require__(41547);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
var Drawer = __webpack_require__(19058);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js
var List = __webpack_require__(18843);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js
var ListItem = __webpack_require__(29861);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Menu.js
var Menu = __webpack_require__(6236);
;// CONCATENATED MODULE: ./src/imports/Navbar/MobileDrawer.js











function MobileDrawer(param) {
    let { links , dark =false  } = param;
    const [open, setOpen] = react.useState(false);
    const { t  } = (0,esm/* useTranslation */.$G)([
        "navbar",
        "common"
    ]);
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStartedButton/* default */.Z, {
                variant: "text",
                size: "small",
                sx: {
                    mr: 1,
                    transition: (theme)=>theme.transitions.create([
                            "padding"
                        ], {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.leavingScreen
                        })
                },
                "aria-label": t("common:get_started_free"),
                color: dark ? "paper" : "primary",
                label: t("common:get_started")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "open drawer",
                onClick: ()=>setOpen(true),
                color: dark ? "paper" : "inherit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                anchor: "right",
                open: open,
                onClose: ()=>setOpen(false),
                PaperProps: {
                    sx: {
                        backgroundColor: "primary.dark",
                        color: "white",
                        borderRadius: 0
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            mt: 2,
                            mb: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            href: "/",
                            onClick: ()=>setOpen(false),
                            "aria-label": t("common:home_page"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                style: {
                                    width: 150,
                                    height: "100%",
                                    objectFit: "contain"
                                },
                                alt: t("common:blue_assembly_logo_white"),
                                src: logo_white
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            width: 250,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                        children: links.map((param, index)=>/*#__PURE__*/ {
                                            let { label , url  } = param;
                                            return (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                                    sx: {
                                                        minHeight: 48,
                                                        justifyContent: open ? "initial" : "center",
                                                        backgroundColor: url === asPath ? "secondary.main" : "",
                                                        ":hover": {
                                                            backgroundColor: "secondary.main"
                                                        },
                                                        px: 2.5
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        sx: {
                                                            color: "inherit"
                                                        },
                                                        textTransform: "capitalize",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: url,
                                                            onClick: ()=>setOpen(false),
                                                            "aria-label": label,
                                                            children: label
                                                        })
                                                    })
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        sx: {
                                            borderColor: "#FFFFFF88"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        sx: {
                                                            color: "inherit"
                                                        },
                                                        textTransform: "capitalize",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: "https://meetings-eu1.hubspot.com/fatimah",
                                                            target: "_blank",
                                                            onClick: ()=>setOpen(false),
                                                            "aria-label": t("common:Request_a_Demo"),
                                                            children: t("common:Request_a_Demo")
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        sx: {
                                                            color: "inherit"
                                                        },
                                                        textTransform: "capitalize",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: "/login",
                                                            onClick: ()=>setOpen(false),
                                                            "aria-label": t("common:login_page"),
                                                            children: t("common:login")
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        sx: {
                                                            color: "inherit"
                                                        },
                                                        textTransform: "capitalize",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: "/register",
                                                            onClick: ()=>setOpen(false),
                                                            "aria-label": t("common:get_started_free"),
                                                            children: t("common:get_started")
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                py: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelect/* default */.Z, {})
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Navbar_MobileDrawer = (MobileDrawer);

;// CONCATENATED MODULE: ./src/imports/Navbar/Navbar.js


















const links = [
    {
        label: "pricing",
        key: "pricing",
        url: "/pricing"
    },
    {
        label: "blog",
        key: "blog",
        url: "/blog"
    },
    {
        label: "help center",
        key: "help_center",
        url: "/help-center"
    },
    {
        label: "contact us",
        key: "contact_us",
        url: "#contact-us"
    }
];
function Navbar(param) {
    let { dark =false  } = param;
    const visible = utils_useScrollBounds(2, 50) // visible (0, 2), threshold (2, 52), not visible (52, infinity)
    ;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "navbar",
        "common"
    ]);
    const { asPath  } = (0,router.useRouter)();
    const linksLocalized = links.map((link)=>({
            ...link,
            label: t("navbar:".concat(link.key)) || link.label
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        elevation: visible ? 0 : 1,
        position: "fixed",
        sx: {
            // eslint-disable-next-line no-nested-ternary
            backgroundColor: visible ? dark ? "primary.main" : "transparent" : "white",
            color: visible && dark ? "white" : "black",
            transition: (theme)=>theme.transitions.create([
                    "background-color",
                    "box-shadow"
                ], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen
                })
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "xl",
            sx: {
                transition: (theme)=>theme.transitions.create([
                        "height"
                    ], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen
                    }),
                height: visible ? 88 : 55
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                sx: {
                    height: "100%",
                    minHeight: "55px !important"
                },
                disableGutters: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: "/",
                        "aria-label": t("common:home_page"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: {
                                    xs: "none",
                                    md: "flex"
                                },
                                mr: 5,
                                height: visible ? 59 : 40,
                                transition: (theme)=>theme.transitions.create([
                                        "box-shadow"
                                    ], {
                                        easing: theme.transitions.easing.sharp,
                                        duration: theme.transitions.duration.leavingScreen
                                    })
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                style: {
                                    height: "100%",
                                    width: "auto"
                                },
                                // layout="responsive"
                                alt: t("common:blue_assembly_logo"),
                                src: visible && dark ? logo_white : logo/* default */.Z
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: "flex",
                                md: "none"
                            },
                            mr: 1,
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            href: "/",
                            "aria-label": t("common:home_page"),
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                height: 30,
                                alt: t("common:blue_assembly_logo"),
                                src: visible && dark ? logo_white : logo/* default */.Z
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: "none",
                                md: "flex"
                            },
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 3,
                            children: linksLocalized.map((param)=>/*#__PURE__*/ {
                                let { label , url  } = param;
                                return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "h1",
                                        // fontFamily="var(--cairo-font)"
                                        variant: "subtitle2",
                                        fontWeight: 500,
                                        sx: {
                                            my: 2,
                                            color: asPath === url ? "secondary.main" : "inherit",
                                            transition: (theme)=>theme.transitions.create([
                                                    "color"
                                                ], {
                                                    easing: theme.transitions.easing.sharp,
                                                    duration: theme.transitions.duration.leavingScreen
                                                }),
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        },
                                        textTransform: "capitalize",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            href: url,
                                            scroll: false,
                                            "aria-label": label,
                                            children: label
                                        })
                                    })
                                }, label);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: "none",
                                md: "flex"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelect/* default */.Z, {
                                        containerProps: {
                                            sx: {
                                                color: "#000"
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "h1",
                                        // fontFamily="var(--cairo-font)"
                                        variant: "subtitle2",
                                        fontWeight: 500,
                                        sx: {
                                            my: 2,
                                            transition: (theme)=>theme.transitions.create([
                                                    "color"
                                                ], {
                                                    easing: theme.transitions.easing.sharp,
                                                    duration: theme.transitions.duration.leavingScreen
                                                }),
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            href: "/login",
                                            scroll: false,
                                            "aria-label": t("common:login_page"),
                                            style: {
                                                textTransform: "capitalize"
                                            },
                                            children: t("common:login")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStartedButton/* default */.Z, {
                                        id: "get-started-button",
                                        label: t("common:get_started"),
                                        size: visible ? "medium" : "small",
                                        sx: {
                                            transition: (theme)=>theme.transitions.create([
                                                    "padding"
                                                ], {
                                                    easing: theme.transitions.easing.sharp,
                                                    duration: theme.transitions.duration.leavingScreen
                                                })
                                        },
                                        color: visible && dark ? "paper" : "primary"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: dark && visible ? "white" : "primary.dark",
                                        component: "h1",
                                        // fontFamily="var(--cairo-font)"
                                        variant: "subtitle2",
                                        fontWeight: 600,
                                        sx: {
                                            my: 2,
                                            ml: 2,
                                            transition: (theme)=>theme.transitions.create([
                                                    "color"
                                                ], {
                                                    easing: theme.transitions.easing.sharp,
                                                    duration: theme.transitions.duration.leavingScreen
                                                }),
                                            ":hover": {
                                                color: "secondary.main"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            href: "https://meetings-eu1.hubspot.com/fatimah",
                                            target: "_blank",
                                            scroll: false,
                                            "aria-label": t("common:Request_a_Demo"),
                                            style: {
                                                textDecoration: "underline"
                                            },
                                            children: t("common:Request_a_Demo")
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: "flex",
                                md: "none"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_MobileDrawer, {
                            dark: visible && dark,
                            links: linksLocalized
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./src/imports/Navbar/index.js


/* harmony default export */ var imports_Navbar = (Navbar_Navbar);

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(37786);
;// CONCATENATED MODULE: ./src/assets/icons/FacebookIcon.js


function SVGComponent(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 28,
        height: 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 0a14 14 0 1 0 0 28 14 14 0 0 0 0-28Zm3.983 9.111c0 .263-.11.368-.369.368-.495 0-.99 0-1.485.02-.493.021-.762.246-.762.761-.011.553 0 1.095 0 1.658h2.12c.302 0 .405.104.405.408v2.221c0 .3-.095.394-.4.396h-2.144v5.994c0 .32-.099.422-.416.422h-2.306c-.278 0-.387-.109-.387-.387v-6.02h-1.831c-.287 0-.39-.105-.39-.394v-2.234c0-.288.108-.396.392-.396h1.829v-1.612a4.032 4.032 0 0 1 .503-2.074c.365-.64.95-1.126 1.645-1.367a4.037 4.037 0 0 1 1.41-.243h1.81c.26 0 .368.114.368.368.01.71.01 1.411.008 2.111Z",
            fill: "#fff"
        })
    });
}
/* harmony default export */ var FacebookIcon = (SVGComponent);

;// CONCATENATED MODULE: ./src/assets/icons/LinkedinIcon.js


function LinkedinIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 28,
        height: 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 0C11.2311 0 8.52431 0.821086 6.22202 2.35943C3.91973 3.89777 2.12532 6.08427 1.06569 8.64243C0.00606595 11.2006 -0.271181 14.0155 0.269012 16.7313C0.809206 19.447 2.14258 21.9416 4.10051 23.8995C6.05845 25.8574 8.55301 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0V0ZM9.92896 21.3684H6.87474V11.5297H9.92896V21.3684ZM8.40001 10.1868C8.04851 10.1883 7.70447 10.0855 7.41137 9.89147C7.11828 9.69743 6.88929 9.42086 6.75335 9.09671C6.61741 8.77256 6.58062 8.41538 6.64763 8.07033C6.71465 7.72527 6.88245 7.40783 7.12984 7.15812C7.37723 6.90842 7.6931 6.73766 8.03751 6.66743C8.38193 6.59721 8.73943 6.63067 9.06484 6.76358C9.39024 6.89649 9.66894 7.12289 9.8657 7.41416C10.0625 7.70544 10.1684 8.0485 10.1703 8.4C10.1713 8.87134 9.98559 9.32389 9.65386 9.65872C9.32213 9.99356 8.87133 10.1834 8.40001 10.1868ZM21.3684 21.3684H18.3161V16.5789C18.3161 15.4368 18.294 13.9724 16.7282 13.9724C15.1624 13.9724 14.8861 15.2139 14.8861 16.4961V21.3684H11.8447V11.5297H14.7755V12.8708H14.8179C15.225 12.0971 16.2216 11.2811 17.7082 11.2811C20.7992 11.2811 21.3684 13.3184 21.3684 15.9637V21.3684Z",
            fill: "white"
        })
    });
}
/* harmony default export */ var icons_LinkedinIcon = (LinkedinIcon);

;// CONCATENATED MODULE: ./src/assets/icons/TwitterIcon.js


function TwitterIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 28,
        height: 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 0C6.27 0 0 6.27 0 14s6.27 14 14 14 14-6.27 14-14S21.73 0 14 0Zm6.392 10.916c.006.137.01.276.01.415 0 4.246-3.233 9.143-9.143 9.143a9.096 9.096 0 0 1-4.926-1.444 6.448 6.448 0 0 0 4.758-1.331 3.217 3.217 0 0 1-3.002-2.232 3.198 3.198 0 0 0 1.451-.055 3.214 3.214 0 0 1-2.578-3.15v-.04a3.2 3.2 0 0 0 1.456.401 3.21 3.21 0 0 1-.995-4.29 9.123 9.123 0 0 0 6.624 3.358 3.214 3.214 0 0 1 5.476-2.93 6.445 6.445 0 0 0 2.04-.78c-.24.75-.75 1.379-1.413 1.777a6.41 6.41 0 0 0 1.845-.506 6.53 6.53 0 0 1-1.603 1.664Z",
            fill: "#fff"
        })
    });
}
/* harmony default export */ var icons_TwitterIcon = (TwitterIcon);

;// CONCATENATED MODULE: ./src/assets/icons/InstagramIcon.js


function InstagramIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 800,
        width: 1200,
        viewBox: "-100.768 -167.947 873.324 1007.682",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#100f0d",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M335.895 0c-91.224 0-102.663.387-138.49 2.021-35.752 1.631-60.169 7.31-81.535 15.612-22.088 8.584-40.82 20.07-59.493 38.743-18.674 18.673-30.16 37.407-38.743 59.495C9.33 137.236 3.653 161.653 2.02 197.405.386 233.232 0 244.671 0 335.895c0 91.222.386 102.661 2.02 138.488 1.633 35.752 7.31 60.169 15.614 81.534 8.584 22.088 20.07 40.82 38.743 59.495 18.674 18.673 37.405 30.159 59.493 38.743 21.366 8.302 45.783 13.98 81.535 15.612 35.827 1.634 47.266 2.021 138.49 2.021 91.222 0 102.661-.387 138.488-2.021 35.752-1.631 60.169-7.31 81.534-15.612 22.088-8.584 40.82-20.07 59.495-38.743 18.673-18.675 30.159-37.407 38.743-59.495 8.302-21.365 13.981-45.782 15.612-81.534 1.634-35.827 2.021-47.266 2.021-138.488 0-91.224-.387-102.663-2.021-138.49-1.631-35.752-7.31-60.169-15.612-81.534-8.584-22.088-20.07-40.822-38.743-59.495-18.675-18.673-37.407-30.159-59.495-38.743-21.365-8.302-45.782-13.981-81.534-15.612C438.556.387 427.117 0 335.895 0zm0 60.521c89.686 0 100.31.343 135.729 1.959 32.75 1.493 50.535 6.965 62.37 11.565 15.68 6.094 26.869 13.372 38.622 25.126 11.755 11.754 19.033 22.944 25.127 38.622 4.6 11.836 10.072 29.622 11.565 62.371 1.616 35.419 1.959 46.043 1.959 135.73 0 89.687-.343 100.311-1.959 135.73-1.493 32.75-6.965 50.535-11.565 62.37-6.094 15.68-13.372 26.869-25.127 38.622-11.753 11.755-22.943 19.033-38.621 25.127-11.836 4.6-29.622 10.072-62.371 11.565-35.413 1.616-46.036 1.959-135.73 1.959-89.694 0-100.315-.343-135.73-1.96-32.75-1.492-50.535-6.964-62.37-11.564-15.68-6.094-26.869-13.372-38.622-25.127-11.754-11.753-19.033-22.943-25.127-38.621-4.6-11.836-10.071-29.622-11.565-62.371-1.616-35.419-1.959-46.043-1.959-135.73 0-89.687.343-100.311 1.959-135.73 1.494-32.75 6.965-50.535 11.565-62.37 6.094-15.68 13.373-26.869 25.126-38.622 11.754-11.755 22.944-19.033 38.622-25.127 11.836-4.6 29.622-10.072 62.371-11.565 35.419-1.616 46.043-1.959 135.73-1.959"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M335.895 447.859c-61.838 0-111.966-50.128-111.966-111.964 0-61.838 50.128-111.966 111.966-111.966 61.836 0 111.964 50.128 111.964 111.966 0 61.836-50.128 111.964-111.964 111.964zm0-284.451c-95.263 0-172.487 77.224-172.487 172.487 0 95.261 77.224 172.485 172.487 172.485 95.261 0 172.485-77.224 172.485-172.485 0-95.263-77.224-172.487-172.485-172.487m219.608-6.815c0 22.262-18.047 40.307-40.308 40.307-22.26 0-40.307-18.045-40.307-40.307 0-22.261 18.047-40.308 40.307-40.308 22.261 0 40.308 18.047 40.308 40.308"
                })
            ]
        })
    });
}
/* harmony default export */ var icons_InstagramIcon = (InstagramIcon);

// EXTERNAL MODULE: ./src/components/ResponsiveButton/index.js + 1 modules
var ResponsiveButton = __webpack_require__(97037);
// EXTERNAL MODULE: ./src/assets/icons/PlayStoreSvg.js
var PlayStoreSvg = __webpack_require__(5380);
// EXTERNAL MODULE: ./src/assets/icons/AppStoreSvg.js
var AppStoreSvg = __webpack_require__(76537);
;// CONCATENATED MODULE: ./src/imports/Footer/Footer.js















const sections = [
    {
        title: "business",
        subsections: [
            {
                title: "privacy_policy",
                href: "/privacy-policy"
            },
            {
                title: "terms_of_services",
                href: "/terms-and-conditions"
            },
            {
                title: "affiliate_program",
                href: "#"
            },
            {
                title: "careers",
                href: "#"
            }
        ]
    },
    {
        title: "information",
        subsections: [
            {
                title: "press_and_media",
                href: "#"
            },
            {
                title: "investors",
                href: "#"
            },
            {
                title: "blog",
                href: "/blog"
            }
        ]
    },
    {
        title: "help",
        subsections: [
            {
                title: "book_a_demo",
                href: "https://meetings-eu1.hubspot.com/fatimah",
                typoProps: {
                    fontWeight: 600,
                    style: {
                        textDecoration: "underline"
                    }
                }
            },
            {
                title: "support",
                href: "/help-center"
            },
            {
                title: "contact_us",
                href: "#contact-us"
            }
        ]
    }
];
function Footer() {
    const { t  } = (0,esm/* useTranslation */.$G)([
        "footer"
    ]);
    var _subsection_typoProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        py: 7,
        sx: {
            backgroundColor: "#24426A",
            color: "primary.contrastText"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 6,
                    children: [
                        sections.map((param, index)=>/*#__PURE__*/ {
                            let { title , subsections  } = param;
                            return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                gutterBottom: true,
                                                variant: "h6",
                                                fontWeight: 700,
                                                children: t("footer:".concat(title))
                                            })
                                        }),
                                        subsections.map((subsection, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    fontWeight: 400,
                                                    sx: {
                                                        ":hover": {
                                                            color: "secondary.main"
                                                        },
                                                        fontSize: {
                                                            xs: "15px !important",
                                                            md: "20px !important"
                                                        }
                                                    },
                                                    ...(_subsection_typoProps = subsection.typoProps) !== null && _subsection_typoProps !== void 0 ? _subsection_typoProps : {},
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        href: subsection.href,
                                                        children: t("footer:".concat(subsection.title))
                                                    })
                                                })
                                            }, idx))
                                    ]
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    mb: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            display: "block",
                                            gutterBottom: true,
                                            variant: "h6",
                                            fontWeight: 700,
                                            children: t("footer:Follow_Us")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            component: Link/* default */.Z,
                                            href: "https://www.facebook.com/blueassembly",
                                            target: "_blank",
                                            "aria-label": "facebook",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookIcon, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            component: Link/* default */.Z,
                                            href: "https://www.linkedin.com/company/blue-assembly/",
                                            target: "_blank",
                                            "aria-label": "linkedin",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LinkedinIcon, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            component: Link/* default */.Z,
                                            href: "https://twitter.com/blueassembly",
                                            target: "_blank",
                                            "aria-label": "twitter",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_TwitterIcon, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            component: Link/* default */.Z,
                                            href: "https://www.instagram.com/blueassemblysa/",
                                            target: "_blank",
                                            "aria-label": "instagram",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InstagramIcon, {
                                                width: 28,
                                                height: 28,
                                                style: {
                                                    backgroundColor: "white",
                                                    borderRadius: "50%"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            display: "block",
                                            gutterBottom: true,
                                            variant: "h6",
                                            fontWeight: 700,
                                            children: t("footer:Download_the_App")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                            variant: "contained",
                                            disableElevation: true,
                                            sx: {
                                                fontWeight: 500,
                                                mb: 1,
                                                width: 200,
                                                px: 0
                                            },
                                            size: "small",
                                            color: "store",
                                            component: "a",
                                            href: "https://play.google.com/store/apps/details?id=com.blueassembly",
                                            target: "_blank",
                                            "aria-label": "google play",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                py: 0.5,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    container: true,
                                                    spacing: 1,
                                                    alignItems: "flex-end",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            sx: {
                                                                lineHeight: 1
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayStoreSvg/* default */.Z, {
                                                                width: 32,
                                                                height: 32
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                            item: true,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "caption",
                                                                    fontSize: 13,
                                                                    display: "block",
                                                                    lineHeight: 1,
                                                                    sx: {
                                                                        pb: 0.5
                                                                    },
                                                                    children: "GET IT ON"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    lineHeight: 1,
                                                                    display: "block",
                                                                    children: "Google Play"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                            variant: "contained",
                                            disableElevation: true,
                                            sx: {
                                                fontWeight: 500,
                                                width: 200,
                                                px: 0
                                            },
                                            size: "small",
                                            color: "store",
                                            component: "a",
                                            href: "https://apps.apple.com/eg/app/blue-assembly/id1591786196",
                                            target: "_blank",
                                            "aria-label": "app store",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                py: 0.5,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    container: true,
                                                    spacing: 1,
                                                    alignItems: "flex-end",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            sx: {
                                                                lineHeight: 1
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreSvg/* default */.Z, {
                                                                fill: "white",
                                                                width: 32,
                                                                height: 32
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                            item: true,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "caption",
                                                                    fontSize: 13,
                                                                    display: "block",
                                                                    lineHeight: 1,
                                                                    sx: {
                                                                        pb: 0.5
                                                                    },
                                                                    children: "Download on the"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    lineHeight: 1,
                                                                    display: "block",
                                                                    children: "App store"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                sx: {
                    mt: 14
                },
                maxWidth: "xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 4,
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                loading: "lazy",
                                height: 40,
                                width: 105,
                                alt: "Blue Assembly logo white",
                                src: logo_white
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            sx: {
                                display: {
                                    xs: "none",
                                    md: "block"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                fontWeight: 700,
                                children: t("footer:all_rights_reserved")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelect/* default */.Z, {
                                containerProps: {
                                    sx: {
                                        color: "white"
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sx: {
                                display: {
                                    xs: "block",
                                    md: "none"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                fontWeight: 700,
                                textAlign: "center",
                                children: t("footer:all_rights_reserved")
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/imports/Footer/index.js


/* harmony default export */ var imports_Footer = (Footer_Footer);

// EXTERNAL MODULE: ./node_modules/@mui/material/useScrollTrigger/useScrollTrigger.js
var useScrollTrigger = __webpack_require__(8298);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(78678);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fab/Fab.js
var Fab = __webpack_require__(98850);
;// CONCATENATED MODULE: ./src/components/ScrollTopButton/ScrollTopButton.js







function ScrollTopButton() {
    const trigger = (0,useScrollTrigger/* default */.Z)({
        disableHysteresis: true,
        threshold: 150
    });
    const handleClick = ()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
        in: trigger,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            onClick: handleClick,
            role: "presentation",
            sx: {
                position: "fixed",
                bottom: 16,
                right: 16,
                zIndex: 10
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "small",
                "aria-label": "scroll back to top",
                color: "primary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {})
            })
        })
    });
}
/* harmony default export */ var ScrollTopButton_ScrollTopButton = (ScrollTopButton);

;// CONCATENATED MODULE: ./src/components/ScrollTopButton/index.js


/* harmony default export */ var components_ScrollTopButton = (ScrollTopButton_ScrollTopButton);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/MainLayout.js






function MainLayout(param) {
    let { children , navbarProps ={}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            overflowX: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(imports_Navbar, {
                ...navbarProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    pt: 11,
                    backgroundColor: navbarProps.dark ? "primary.main" : "transparent"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScrollTopButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(imports_Footer, {})
        ]
    });
}
/* harmony default export */ var MainLayout_MainLayout = (MainLayout);

;// CONCATENATED MODULE: ./src/layouts/MainLayout/index.js


/* harmony default export */ var layouts_MainLayout = (MainLayout_MainLayout);


/***/ })

}]);